export function fmtMoney(v, currency = "USD") {
    if (v === null || v === undefined || isNaN(v)) return "—";
    try {
        return new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 }).format(v);
    } catch {
        return `$${Number(v).toFixed(0)}`;
    }
}

export function fmtPct(v) {
    if (v === null || v === undefined || isNaN(v)) return "—";
    return `${Number(v).toFixed(1)}%`;
}

export function fmtRatio(v) {
    if (v === null || v === undefined || isNaN(v)) return "—";
    return Number(v).toFixed(2) + "x";
}

export function fmtNum(v) {
    if (v === null || v === undefined || isNaN(v)) return "—";
    return new Intl.NumberFormat("en-US").format(v);
}

export function fmtBy(kind, v, currency) {
    if (kind === "money") return fmtMoney(v, currency);
    if (kind === "pct") return fmtPct(v);
    if (kind === "ratio") return fmtRatio(v);
    return fmtNum(v);
}
